import React from 'react';
import './style.scss';
import useAddVendingMachine from './hooks';
import AddHeader from '../../../../components/layout/header/add';
import RenderVMConfig from './RenderVMConfig';
import Form from '../../../../components/molecules/forms';
import Button from '../../../../components/molecules/buttons';

function AddVendingMachine() {
  const {
    vmId, vmModelList, vmModelListLoading, clientListLoading, clientList,
    formik, addVMLoad, addCoffeeLoad, vmConfigLoading, sortedVM, handleCurrentConfig,
    onPreviousVmConfig, onNextVmConfig, handleChooseConfig, navigateToVM,
    isCoffee, isWholesale, clientName, coffeeModelLoad,
  } = useAddVendingMachine();

  let myTitle : {title: string, route: string};
  let title = '';
  let machine = '';
  if (!isCoffee && !isWholesale) {
    myTitle = { title: 'Vending Machine', route: '/vending-machine' };
    title = 'Vending';
    machine = 'Vending';
  } else if (!isWholesale) {
    myTitle = { title: 'Coffee Machine', route: '/coffee-machine' };
    title = 'Coffee';
    machine = 'Coffee';
  } else {
    myTitle = { title: 'Wholesale Distribution', route: '/wholesale' };
    title = 'Wholesale';
    machine = 'C-Store';
  }

  return (
    <div>
      <AddHeader
        primary={myTitle}
        title={clientName ? `Edit A ${!isCoffee && !isWholesale ? 'Vending' : 'Coffee'} Machine`
          : `Add ${title} Machine`}
      />
      <form onSubmit={formik.handleSubmit} aria-label="form">
        <div className="mb-5">
          <div className="px-4 px-xl-5">
            <div className="fz-16 fw-bold mb-3">
              {clientName ? `Edit ${machine} Machine Info`
                : `${machine} Machine Info`}
            </div>
            <Form.Default
              id="deviceId"
              label="Device Id"
              placeholder="Enter Device Id"
              value={formik.values.deviceId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.deviceId && !!formik.errors.deviceId}
              errorMsg={formik.errors.deviceId}
              className="mb-4"
            />
            <Form.ReactSelect.Default
              id="model"
              label="Machine Model"
              placeholder="Choose Machine Model"
              options={vmModelList}
              disabled={!isCoffee && !isWholesale ? vmModelListLoading : coffeeModelLoad}
              value={vmModelList?.find((x: any) => x.value.toString() === formik.values.model.toString())}
              onChange={(e) => {
                if (e) formik.setFieldValue('model', e.value);
              }}
              isInvalid={formik.touched.model && !!formik.errors.model}
              errorMsg={formik.errors.model}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>
        <div className="w-100 bg-stroke" style={{ height: '7px' }} />
        <div className="my-5">
          <div className="px-4 px-xl-5">
            <div className="fz-16 fw-bold mb-3">
              {vmId ? 'Edit Client Info' : 'Client Info'}
            </div>
            <div className="row">
              <div className="col-lg-5">
                <Form.ReactSelect.Default
                  id="clientId"
                  label="Search or choose a client for this machine"
                  placeholder="Client Name"
                  options={clientList}
                  disabled={clientListLoading}
                  value={clientList?.find((x: any) => x.value.toString() === formik.values.clientId.toString())}
                  onChange={(e) => {
                    if (e) formik.setFieldValue('clientId', e.value);
                  }}
                  isInvalid={formik.touched.clientId && !!formik.errors.clientId}
                  errorMsg={formik.errors.clientId}
                  onBlur={formik.handleBlur}
                  className="mb-4 mb-lg-0"
                />
              </div>
              <div className="col-lg-7">
                <Form.Default
                  id="location"
                  label="Enter Location"
                  placeholder="Enter Location"
                  value={formik.values.location}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.touched.location && !!formik.errors.location}
                  errorMsg={formik.errors.location}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 bg-stroke mb-5" style={{ height: '7px' }} />
        <div className={formik.values.model && !isCoffee && !isWholesale ? 'w-100' : 'd-none'}>
          <RenderVMConfig
            formik={formik}
            sortedVM={sortedVM}
            isLoading={vmConfigLoading}
            onPreviousVmConfig={onPreviousVmConfig}
            onNextVmConfig={onNextVmConfig}
            handleChooseConfig={handleChooseConfig}
            handleCurrentConfig={handleCurrentConfig}
          />
          <div className="w-100 bg-stroke my-5" style={{ height: '7px' }} />
        </div>
        <div className="d-flex justify-content-end px-4 px-xl-5 pb-4">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              outline
              onClick={navigateToVM}
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="save"
              type="submit"
              label="Save Changes"
              size="lg"
              loading={addVMLoad || addCoffeeLoad}
            // disabled={!clientName}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddVendingMachine;
